import { Button } from "reactstrap";

import {
  FormBuilder,
  FormBuilderField,
} from "../../../types/FormBuilderInterfaces";
import InputFormatter from "../../Records/Formatters/InputFormatter";
import SubitemRenderer from "../../Records/Subitems/SubitemRenderer";
import { Module } from "../../../types/TenantInterfaces";
import Constants from "../../../utils/Constants";

interface Props {
  form: FormBuilder;
  module?: Module;
}

const fieldsPerRow: any = {
  "1": "100%",
  "2": "calc(50% - 1em)",
  "3": "calc(33.33% - 1em)",
  "4": "calc(25% - 1em)",
};

const buttonSizes: any = {
  Small: "auto",
  Medium: "50%",
  Large: "100%",
};

const buttonPositions: any = {
  Left: "start",
  Center: "center",
  Right: "end",
};

const Form = ({ form, module }: Props) => {
  const hasSections = form.Layout?.sections?.length
    ? form.Layout?.sections?.length > 0
    : false;

  const getFieldInput = (fieldKey: FormBuilderField) => {
    const fieldType = fieldKey.Field.FieldType;

    if (
      fieldType === Constants.FIELDTYPES.MULTI_SUBITEM ||
      fieldType === Constants.FIELDTYPES.SUBITEM
    ) {
      return (
        <SubitemRenderer
          key={fieldKey.Field.APIName}
          module={module!}
          field={fieldKey.Field}
          prefill={undefined}
          subItemValues={{}}
          defaultSub={undefined}
          handleChange={() => {}}
          disableReadonlyFields={true}
        />
      );
    }

    return (
      <div
        key={fieldKey.Field.APIName}
        style={{
          width: fieldsPerRow[form.FieldStyles?.FieldsPerRow],
        }}
      >
        <div className="d-flex justify-content-between">
          <label
            className="text-sm font-weight-bold"
            style={{ color: form.FieldStyles.LabelsColor }}
          >
            {fieldKey.Settings?.Label}
          </label>
          {fieldKey.Settings?.Required && (
            <i className="mdi mdi-asterisk" style={{ color: "red" }}></i>
          )}
        </div>
        <InputFormatter
          key={fieldKey.Field.APIName}
          /* @ts-ignore */
          module={{ APIName: form?.ModuleAPIName }}
          field={fieldKey.Field}
          value={fieldKey.Settings?.Default}
          // TODO: Add support for "style" prop in InputFormatter
          // style={{
          //   borderRadius: `${form.FieldStyles?.BorderRadius}px`,
          //   borderColor: form.FieldStyles.InputBorderColor,
          //   color: form.FieldStyles?.TextColor,
          //   backgroundColor: form.FieldStyles.BackgroundColor,
          // }}
          //@ts-ignore
          placeholder={fieldKey.Settings?.Placeholder}
        />
      </div>
    );
  };

  return (
    <div
      className="d-flex flex-column border shadow-lg p-3"
      style={{
        gap: "10px",
        width: "700px",
        boxSizing: "border-box",
        borderRadius: `${form.FormStyles?.BorderRadius}px`,
        backgroundColor: form.FormStyles?.BackgroundColor,
      }}
    >
      {form.Header?.CoverImage?.PublicURL && (
        <img
          src={form.Header?.CoverImage?.PublicURL}
          alt="Cover-Image"
          style={{
            maxWidth: "100%",
            height: "250px",
            objectFit: "cover",
            objectPosition: "50% 50%",
          }}
        />
      )}
      <h1 style={{ color: form.GeneralStyles?.TitleColor }}>
        {form.Header?.Title || "Title"}
      </h1>
      <p style={{ color: form.GeneralStyles?.DescriptionColor }}>
        {form.Header?.Description || "Description"}
      </p>

      {hasSections ? (
        form?.Layout?.sections.map((section) => {
          return (
            <div key={section.id} className="d-flex flex-column w-full">
              <div className="d-flex flex-column mb-4">
                <h2>{section.Title}</h2>
                <span>{section.Description}</span>
              </div>
              <div
                className="d-flex flex-wrap mb-4"
                style={{ rowGap: "10px", columnGap: "10px" }}
              >
                {section.Fields.map((field: any) => {
                  const fieldKey = form.Fields?.[field.Field.APIName];
                  if (!fieldKey) return;
                  return getFieldInput(fieldKey);
                })}
              </div>
            </div>
          );
        })
      ) : (
        <div
          className="d-flex flex-wrap"
          style={{ rowGap: "10px", columnGap: "10px" }}
        >
          {form.Fields &&
            Object.keys(form.Fields).map((field) => {
              const fieldKey = form.Fields?.[field];
              if (!fieldKey) return;
              return getFieldInput(fieldKey);
            })}
        </div>
      )}
      <Button
        size="md"
        className="mt-3"
        style={{
          width:
            buttonSizes[
              form.ButtonStyles?.Size ? form.ButtonStyles?.Size : "Small"
            ],
          borderRadius: `${form.ButtonStyles?.BorderRadius}px`,
          color: form.ButtonStyles?.TextColor,
          backgroundColor: form.ButtonStyles?.BackgroundColor,
          borderColor: form.ButtonStyles?.BackgroundColor,
          alignSelf:
            buttonPositions[
              form.ButtonStyles?.Position
                ? form.ButtonStyles?.Position
                : "Start"
            ],
        }}
      >
        {form.ButtonStyles?.ButtonText}
      </Button>
    </div>
  );
};

export default Form;
